(function(){
  function init(root){
    if(!root||root.dataset.pasabeluMenuReady==='true')return;
    root.dataset.pasabeluMenuReady='true';

    const mainScreen=root.querySelector('[data-pasabelu-main-screen]');

    function getPanels(){
      return Array.from(root.querySelectorAll('[data-pasabelu-panel]'));
    }

    function getTriggers(){
      return Array.from(root.querySelectorAll('[data-pasabelu-open-panel]'));
    }

    function resetExpanded(){
      getTriggers().forEach(function(el){
        el.setAttribute('aria-expanded','false');
      });
    }

    function closePanels(){
      root.classList.remove('is-submenu-open');
      resetExpanded();

      getPanels().forEach(function(panel){
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden','true');
      });

      if(mainScreen){
        mainScreen.removeAttribute('aria-hidden');
      }

      const drawerBody=root.closest('#HeaderDrawer_Body,.header-drawer-v2__body');
      if(drawerBody){
        drawerBody.scrollTop=0;
      }
    }

    function openPanel(index,trigger){
      const panel=root.querySelector('[data-pasabelu-panel="'+index+'"]');
      if(!panel)return;

      getPanels().forEach(function(item){
        item.classList.remove('is-active');
        item.setAttribute('aria-hidden','true');
      });

      resetExpanded();

      if(trigger){
        trigger.setAttribute('aria-expanded','true');
      }

      root.classList.add('is-submenu-open');
      panel.classList.add('is-active');
      panel.setAttribute('aria-hidden','false');

      if(mainScreen){
        mainScreen.setAttribute('aria-hidden','true');
      }

      const drawerBody=root.closest('#HeaderDrawer_Body,.header-drawer-v2__body');
      if(drawerBody){
        drawerBody.scrollTop=0;
      }
    }

    function closeNativeDrawer(){
      closePanels();

      const drawerWrapper=root.closest('.header-drawer-v2,.menu-drawer-container,.drawer,drawer-menu,details');

      const closeSelectors=[
        'button[name="close"]',
        '[data-drawer-close]',
        '[data-close]',
        '[aria-label="Close"]',
        '[aria-label="close"]',
        '[aria-label="Cerrar"]',
        '[aria-label="cerrar"]',
        '.drawer__close',
        '.modal__close-button',
        '.header-drawer-v2__close',
        '.menu-drawer__close-button',
        '.header__icon--menu'
      ].join(',');

      const searchArea=drawerWrapper||document;
      const nativeCloseButton=Array.from(searchArea.querySelectorAll(closeSelectors)).find(function(button){
        return !root.contains(button);
      });

      if(nativeCloseButton){
        nativeCloseButton.click();
        return;
      }

      let current=root.parentElement;

      while(current){
        if(current.tagName==='DETAILS'&&current.hasAttribute('open')){
          current.removeAttribute('open');

          const summary=current.querySelector('summary');
          if(summary){
            summary.setAttribute('aria-expanded','false');
          }
        }

        current=current.parentElement;
      }

      document.querySelectorAll('details[open]').forEach(function(details){
        const id=details.getAttribute('id')||'';
        const cls=details.className||'';

        if(
          id.toLowerCase().includes('drawer')||
          id.toLowerCase().includes('menu')||
          cls.toLowerCase().includes('drawer')||
          cls.toLowerCase().includes('menu')
        ){
          details.removeAttribute('open');

          const summary=details.querySelector('summary');
          if(summary){
            summary.setAttribute('aria-expanded','false');
          }
        }
      });

      document.body.classList.remove(
        'overflow-hidden',
        'overflow-hidden-mobile',
        'menu-opening',
        'drawer-open'
      );

      document.documentElement.classList.remove(
        'overflow-hidden',
        'lock-scroll',
        'drawer-open'
      );

      document.dispatchEvent(new KeyboardEvent('keydown',{
        key:'Escape',
        code:'Escape',
        keyCode:27,
        which:27,
        bubbles:true
      }));
    }

    function openAccordion(details,content){
      details.open=true;
      details.classList.add('is-opening');
      details.classList.remove('is-closing');

      content.style.height='0px';
      content.style.opacity='0';
      content.style.transform='translate3d(0,-2px,0)';

      requestAnimationFrame(function(){
        content.style.height=content.scrollHeight+'px';
        content.style.opacity='1';
        content.style.transform='translate3d(0,0,0)';
      });

      window.setTimeout(function(){
        if(details.open){
          content.style.height='auto';
          details.classList.remove('is-opening');
        }
      },300);
    }

    function closeAccordion(details,content){
      details.classList.add('is-closing');
      details.classList.remove('is-opening');

      content.style.height=content.scrollHeight+'px';
      content.style.opacity='1';
      content.style.transform='translate3d(0,0,0)';

      requestAnimationFrame(function(){
        content.style.height='0px';
        content.style.opacity='0';
        content.style.transform='translate3d(0,-2px,0)';
      });

      window.setTimeout(function(){
        details.open=false;
        details.classList.remove('is-closing');
      },260);
    }

    function handleControlClick(event){
      const opener=event.target.closest('[data-pasabelu-open-panel]');
      if(opener&&root.contains(opener)){
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openPanel(opener.getAttribute('data-pasabelu-open-panel'),opener);
        return true;
      }

      const back=event.target.closest('[data-pasabelu-back]');
      if(back&&root.contains(back)){
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closePanels();
        return true;
      }

      const close=event.target.closest('[data-pasabelu-close]');
      if(close&&root.contains(close)){
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closeNativeDrawer();
        return true;
      }

      const summary=event.target.closest('[data-pasabelu-accordion]>summary');
      if(summary&&root.contains(summary)){
        const details=summary.parentElement;
        const content=details.querySelector('[data-pasabelu-accordion-content]');

        if(!content)return false;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if(details.open){
          closeAccordion(details,content);
        }else{
          openAccordion(details,content);
        }

        return true;
      }

      return false;
    }

    root.addEventListener('click',function(event){
      handleControlClick(event);
    },true);

    root.addEventListener('click',function(event){
      if(event.target.closest('a')&&root.contains(event.target.closest('a'))){
        event.stopPropagation();
      }
    });
  }

  function initAll(){
    document.querySelectorAll('[data-pasabelu-menu]').forEach(init);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initAll,{once:true});
  }else{
    initAll();
  }

  document.addEventListener('shopify:section:load',initAll);
  document.addEventListener('shopify:block:select',initAll);
})();